import dynamic from "next/dynamic";
import AsymmetricEnterpriseConfig from "./asymmetric-enterprise-config";
import AsymmetricEnterpriseAdvancedConfig from "./asymmetric-enterprise-advanced-config";
const AsymmetricEnterpriseComponent = dynamic(()=>import("./asymmetric-enterprise-component"));
export default {
    AsymmetricEnterpriseComponent,
    AsymmetricEnterpriseConfig,
    AsymmetricEnterpriseAdvancedConfig
};
